









import { Component, Vue } from "vue-property-decorator";
import ChangePasswordForm from "./components/change-password/ChangePasswordForm.vue";

@Component({
  name: "UserChangePassword",
  components: {
    ChangePasswordForm,
  },
})
export default class UserChangePassword extends Vue {

  
}
